export default __webpack_public_path__ + "static/media/Resources.f6a12edf.svg";